export const validateVideoUrl = (url) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.onerror = () => reject(new Error('error'));
        video.onloadedmetadata = () => resolve('success');
        video.src = url;
    });
};
